import { render, staticRenderFns } from "./OverviewTable.vue?vue&type=template&id=5f4169cc"
import script from "./OverviewTable.vue?vue&type=script&lang=ts"
export * from "./OverviewTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports